module.exports = {

    dropzoneOptions(baseURL) {
        return {
            url: baseURL + `/upload/`,
            thumbnailWidth: 150,
            thumbnailHeight: 150,
            maxFilesize: 8,
            autoProcessQueue: false,
            uploadMultiple: false,
            addRemoveLinks: true,
            dictDefaultMessage: "Click or drag and drop to upload file",
            dictRemoveFile: "x",
            withCredentials: true,

            accept: function (file, done) {
                console.log(file);
                if (file.type != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                    done("Error! Files of this type are not accepted");
                }
                else { done(); }
            },

        };
    }

};